import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import NewsHeader from "@/components/feature/NewsHeader";
import NewsFooter from "@/components/feature/NewsFooter";
import BackToTop from "@/components/feature/BackToTop";

export default function SiteLayout() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [pathname]);

  return (
    <div id="top" className="min-h-screen flex flex-col">
      <NewsHeader />
      <main className="flex-1">
        <Outlet />
      </main>
      <NewsFooter />
      <BackToTop />
    </div>
  );
}